
import { lazy, Suspense } from "react";
import { usePageTitle } from '@/hooks/usePageTitle';
import { TableSkeleton } from '@/components/ui/skeletons';
import { PageHeader } from '@/components/ui/page-header';
import { PageHeaderActionsProvider } from '@/components/ui/page-header-actions';

const ProjectsTable = lazy(
  () => import('@/components/projects/projects-table').then(m => ({ default: m.ProjectsTable }))
);

function ProjectsPage() {
  usePageTitle('Projects');

  return (
    <PageHeaderActionsProvider>
      <div className="flex flex-col gap-2 flex-1 min-h-0">
        <PageHeader title="Projects" askAi />
        <ProjectsTable />
      </div>
    </PageHeaderActionsProvider>
  );
}

import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/projects')({
  component: ProjectsPage,
  pendingComponent: () => <div className="flex flex-col gap-4 flex-1 min-h-0"><TableSkeleton rows={8} /></div>,
  pendingMs: 0,
  pendingMinMs: 150,
});
